import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Kicker, H2 } from './ui/Typography';
import { useT } from '../i18n/LanguageContext';
export function DifferenceSection() {
  const t = useT().difference;
  return <Section hasOrb={false} data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <div className="flex justify-center" data-id="element-21">
            <Kicker data-id="element-22">{t.kicker}</Kicker>
          </div>
          <H2 data-id="element-23">
            {t.title1} <span className="text-brand" data-id="element-24">{t.title2}</span>
          </H2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.01
      }} transition={{
        duration: 0.5
      }} className="border-[2px] border-border rounded-[16px] overflow-hidden bg-surface" data-id="element-25">
          <div className="grid grid-cols-2 border-b-[2px] border-border bg-[rgba(255,255,255,0.02)]" data-id="element-26">
            <div className="p-6 text-center font-mono text-sm text-ink-dim uppercase tracking-wider" data-id="element-27">
              {t.col1}
            </div>
            <div className="p-6 text-center font-mono text-sm text-brand uppercase tracking-wider border-l-[2px] border-border" data-id="element-28">
              {t.col2}
            </div>
          </div>

          {t.rows.map((row, i) => <div key={i} className="grid grid-cols-2 border-b-[2px] border-border last:border-b-0" data-id="element-29">
              <div className="p-6 flex items-center gap-4 text-ink-dim opacity-70" data-id="element-30">
                <span className="text-red-500 font-bold shrink-0" data-id="element-31">✕</span>
                <span data-id="element-32">{row.bad}</span>
              </div>
              <div className="p-6 flex items-center gap-4 text-ink font-medium border-l-[2px] border-border bg-[rgba(250,255,0,0.02)]" data-id="element-33">
                <span className="text-brand font-bold shrink-0" data-id="element-34">✓</span>
                <span data-id="element-35">{row.good}</span>
              </div>
            </div>)}
        </motion.div>
      </div>
    </Section>;
}